<template>
  <div>
    <van-row class="content" v-if="data.organizer != null">
      <van-col :span="24" class="img">
        <img src="@/assets/images/master.png" alt="" />
      </van-col>
      <van-col :span="24" class="text">
        <p>主办单位：</p>
        <div>{{ data.organizer }}</div>
      </van-col>
      <!-- <van-col :span="24">
        <p>支持单位：</p>
        <div>国际商会中国国家委员会秘书局</div>
      </van-col> -->
    </van-row>
    <van-row class="content" v-if="data.coOrganizer != null">
      <van-col :span="24" class="img">
        <img src="@/assets/images/employ.png" alt="" />
      </van-col>
      <van-col :span="24" class="text">
        <p>承办单位：</p>
        <div>{{ data.coOrganizer }}</div>
      </van-col>
      <!-- <van-col :span="24">
        <p>支持单位：</p>
        <div>国际商会中国国家委员会秘书局</div>
      </van-col> -->
    </van-row>
    <van-row class="content" v-if="data.contactPerson != null || data.phone != null || data.email != null">
      <van-col :span="24" class="img">
        <img src="@/assets/images/contacts.png" alt="" />
      </van-col>
      <van-col :span="24" class="text">
        <van-row>
          <van-col :span="12" v-if="data.contactPerson != null">
            姓名：<span>{{ data.contactPerson }}</span>
          </van-col>
          <van-col :span="12" v-if="data.phone != null">
            电话：<span>{{ data.phone }}</span>
          </van-col>
          <van-col :span="18" v-if="data.email != null">
            邮箱：<span>{{ data.email }}</span>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin-bottom: 25px;

  .van-col {
    display: flex;
    align-content: center;
    justify-content: left;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 15px;

    p {
      width: 70px;
    }

    >div {
      width: calc(100% - 70px);
      text-align: left;
    }

    .van-row {
      width: 100%;
    }
  }

  .img {
    justify-content: center;

    img {
      width: 93px;
      height: 35px;
    }
  }
}
</style>